export const mainConfig = {
    tableId: 'cameraConfiguration',
    urlPath: 'monitoring/element/all',
};

export const tableColumnsConfig = [
    {
        columns: [
            {
                caption: 'Status',
                dataField: 'status',
                dataType: 'boolean',
                editable: false,
                fixed: true,
                width: 80,
            },
            {
                caption: 'ID',
                dataField: 'id',
                dataType: 'string',
                editable: false,
                fixed: true,
                width: 100,
            },
            {
                caption: 'Location',
                dataField: 'location.yardName',
                dataType: 'string',
                editable: false,
                fixed: true,
                width: 200,
            },
            {
                caption: 'Family',
                dataField: 'family.name',
                dataType: 'string',
                editable: false,
                fixed: true,
                width: 100,
            },
            {
                caption: 'Name',
                dataField: 'name',
                dataType: 'string',
                editable: false,
                fixed: true,
                width: 160,
            },
        ],
    },
    {
        caption: 'General',
        columns: [
            {
                caption: 'Element Type',
                dataField: 'elementType',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Monitoring Object',
                dataField: 'monitoringObjects',
                dataType: 'string',
                editable: false,
                width: 300,
            },
            {
                caption: 'Class',
                dataField: 'monitoringElementClass',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Note',
                dataField: 'note',
                dataType: 'string',
                editable: false,
                width: 120,
            },
        ],
    },
    {
        caption: 'Device',
        columns: [
            {
                caption: 'Manufacturer',
                dataField: 'manufacturer.name',
                dataType: 'string',
                editable: false,
                width: 150,
            },

            {
                caption: 'Model',
                dataField: 'model',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Serial Number',
                dataField: 'deviceSerialNumber',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Software Version',
                dataField: 'softwareVersion',
                dataType: 'string',
                editable: false,
                width: 120,
            },
        ],
    },

    {
        caption: 'Network',
        columns: [
            {
                caption: 'MAC Address',
                dataField: 'macAddress',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Subnet Mask',
                dataField: 'subnetMask',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'IPv4 Address',
                dataField: 'ipv4Address',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'IPv4 Gateway',
                dataField: 'ipv4Gateway',
                dataType: 'string',
                editable: false,
                width: 120,
            },

            {
                caption: 'RTSP Port',
                dataField: 'port',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'HTTP Port',
                dataField: 'portHttp',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'External Port',
                dataField: 'portExternal',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'HTTPS',
                dataField: 'ssl',
                dataType: 'string',
                editable: false,
                width: 120,
            },
        ],
    },
    {
        caption: 'Wi-Fi settings',
        columns: [
            {
                caption: 'SSID',
                dataField: 'ssid',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'WPA Preshared Key',
                dataField: 'wpaPresharedKey',
                dataType: 'string',
                editable: false,
                width: 120,
            },

            {
                caption: 'Username',
                dataField: 'username',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Password',
                dataField: 'password',
                dataType: 'string',
                editable: false,
                width: 120,
            },
        ],
    },
    {
        caption: 'MMTX Main Stream',
        columns: [
            {
                caption: 'Source',
                dataField: 'sourceMain',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Type',
                dataField: 'streamProcessingMain',
                dataType: 'string',
                editable: false,
                width: 180,
            },
            {
                caption: 'Latency Parameters',
                dataField: 'streamLatencyMain',
                dataType: 'number',
                editable: false,
                width: 120,
            },
            {
                caption: 'Parameters',
                dataField: 'streamParametersMain',
                dataType: 'string',
                editable: false,
                width: 120,
            },
        ],
    },
    {
        caption: 'MMTX Sub Stream',
        columns: [
            {
                caption: 'Source',
                dataField: 'sourceSub',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Latency Parameters Sub',
                dataField: 'streamLatencySub',
                dataType: 'number',
                editable: false,
                width: 120,
            },
            {
                caption: 'Type',
                dataField: 'streamProcessingSub',
                dataType: 'string',
                editable: false,
                width: 180,
            },
            {
                caption: 'Parameters',
                dataField: 'streamParametersSub',
                dataType: 'string',
                editable: false,
                width: 120,
            },
        ],
    },
    {
        caption: 'MMTX',
        columns: [
            {
                caption: 'MMTX Name',
                dataField: 'mediaProxyName',
                dataType: 'string',
                editable: false,
                width: 120,
            },
            {
                caption: 'Direct (WebRTC On)',
                dataField: 'mtxDirect',
                dataType: 'string',
                editable: false,
                width: 120,
            },
        ],
    },
    {
        caption: 'Stream Source',
        columns: [
            {
                caption: 'NVR Id',
                dataField: 'nvrId',
                dataType: 'string',
                editable: false,
                width: 100,
            },
            {
                caption: 'NVR Channel',
                dataField: 'nvrChannelNumber',
                dataType: 'string',
                editable: false,
                width: 100,
            },
        ],
    },
    {
        caption: 'Streams URLs',
        columns: [
            {
                caption: 'Main Stream Camera URL',
                dataField: 'urlStreamQualityMain',
                dataType: 'string',
                editable: false,
                width: 350,
            },
            {
                caption: 'Sub Stream Camera URL',
                dataField: 'urlStreamQualitySub',
                dataType: 'string',
                editable: false,
                width: 320,
            },
            {
                caption: 'Main Stream NVR URL',
                dataField: 'urlNvrStreamQualityMain',
                dataType: 'string',
                editable: false,
                width: 350,
            },
            {
                caption: 'Sub Stream NVR URL',
                dataField: 'urlNvrStreamQualitySub',
                dataType: 'string',
                editable: false,
                width: 350,
            },
            {
                caption: 'Main Stream MMTX URL',
                dataField: 'urlProxyStreamQualityMain',
                dataType: 'string',
                editable: false,
                width: 300,
            },
            {
                caption: 'Sub Stream MMTX URL',
                dataField: 'urlProxyStreamQualitySub',
                dataType: 'string',
                editable: false,
                width: 300,
            },
        ],
    },
];
